var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-lot-container"},[_c('logo'),_c('lots',{staticClass:"lots"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }